module.exports = __webpack_public_path__ + "static/media/exit_icon.d09ef311.svg";